import { toast } from 'react-toastify';

const defaultToastNotificationConfiguration = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
}

export const showUserNotification = {
    info: (message = "", configs = {}) => {
        toast.info(message, { ...defaultToastNotificationConfiguration, ...configs });
    },
    warn: (message = "", configs = {}) => {
        toast.warn(message, { ...defaultToastNotificationConfiguration, ...configs });
    },
    success: (message = "", configs = {}) => {
        toast.success(message, { ...defaultToastNotificationConfiguration, ...configs });
    },
    error: (message = "", configs = {}) => {
        toast.error(message, { ...defaultToastNotificationConfiguration, ...configs });
    },
    notice: (message = "", configs = {}) => {
        toast(message, configs);
    },

}

export const showPromiseNotification = (promise, pendingMsg = 'Your request is processing ...', defaultErrorMsg = 'Something Went wrong', configs = {}) => {
    configs = { ...defaultToastNotificationConfiguration, ...configs };
    toast.promise(promise,
        {
            pending: pendingMsg,
            success: {
                render({ data }) {
                    return data;
                },
            },
            error: {
                render({ error }) {
                    return error ?? defaultErrorMsg;
                }
            }
        }, configs);
}